import styled from "styled-components"

export const Wrapper = styled.div`
  display: grid;
  row-gap: 40px;
`
